import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, vModelRadio as _vModelRadio, withDirectives as _withDirectives, normalizeClass as _normalizeClass, vModelText as _vModelText, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "signup-shell" }
const _hoisted_2 = {
  class: "brand-panel",
  "aria-label": "Bati Vision 360"
}
const _hoisted_3 = { class: "brand-topbar" }
const _hoisted_4 = { class: "brand-copy" }
const _hoisted_5 = { class: "eyebrow" }
const _hoisted_6 = { class: "trial-message" }
const _hoisted_7 = { class: "brand-foot" }
const _hoisted_8 = { class: "form-panel" }
const _hoisted_9 = {
  class: "form-card",
  "aria-live": "polite"
}
const _hoisted_10 = { class: "intro" }
const _hoisted_11 = { class: "account-types" }
const _hoisted_12 = { class: "sr-only" }
const _hoisted_13 = { class: "two-col" }
const _hoisted_14 = { class: "two-col" }
const _hoisted_15 = {
  class: "strength",
  "aria-live": "polite"
}
const _hoisted_16 = { class: "hint" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { class: "hint" }
const _hoisted_19 = { class: "consent" }
const _hoisted_20 = {
  key: 1,
  class: "error",
  role: "alert"
}
const _hoisted_21 = ["disabled"]
const _hoisted_22 = { class: "intro" }
const _hoisted_23 = {
  key: 0,
  class: "error",
  role: "alert"
}
const _hoisted_24 = ["disabled"]
const _hoisted_25 = ["disabled"]
const _hoisted_26 = { class: "eyebrow orange" }
const _hoisted_27 = { class: "intro" }
const _hoisted_28 = { class: "username-box" }
const _hoisted_29 = { class: "hint centered" }
const _hoisted_30 = {
  key: 3,
  class: "signin"
}

import { computed, nextTick, reactive, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import signupService, { type AccountSignupRequestDto, type SignupResponseDto } from '@/services/signup.service'
import LanguageSelector from '@/components/common/LanguageSelector.vue'
import { getPasswordStrength } from '@/utils/passwordValidation'


export default /*@__PURE__*/_defineComponent({
  __name: 'SignUpPage',
  emits: ["signIn"],
  setup(__props) {


const { t, locale } = useI18n()
const step = ref(1), busy = ref(false), error = ref(''), otp = ref(''), confirmPassword = ref('')
const result = ref<SignupResponseDto | null>(null), copied = ref(false), resendWait = ref(0)
const otpInput = ref<HTMLInputElement | null>(null)
const form = reactive<AccountSignupRequestDto>({ firstName: '', lastName: '', email: '', password: '', type: 'FIRM_OWNER', securityCode: '', acceptedTerms: false, termsVersion: '2026-08-11' })
const passwordStrength = computed(() => getPasswordStrength(form.password))

function validate() {
  if (!form.firstName || !form.lastName || !signupService.validateEmail(form.email)) return t('registration.requiredError')
  if (!signupService.validatePassword(form.password)) return t('registration.passwordError')
  if (form.password !== confirmPassword.value) return t('registration.passwordMismatch')
  if ((form.type === 'CLIENT' || form.type === 'FIRM_MEMBER') && !form.securityCode) return t('registration.invitationRequired')
  if (!form.acceptedTerms) return t('registration.legalRequired')
  return ''
}
async function requestOtp() {
  error.value = validate(); if (error.value) return
  busy.value = true
  try {
    const check = await signupService.checkEmailExists(form.email)
    if (check.exists) throw new Error(t('registration.emailExists'))
    await signupService.sendOtp(form.email, locale.value)
    step.value = 2; startTimer(); await nextTick(); otpInput.value?.focus()
  } catch (e: any) { error.value = e?.message || t('registration.genericError') }
  finally { busy.value = false }
}
async function completeSignup() {
  busy.value = true; error.value = ''
  try {
    const verified = await signupService.verifyOtp(form.email, otp.value)
    if (!verified.success) throw new Error(t('registration.invalidCode'))
    result.value = await signupService.createAccount({ ...form, securityCode: form.type === 'CLIENT' || form.type === 'FIRM_MEMBER' ? form.securityCode : undefined })
    step.value = 3
  } catch (e: any) { error.value = e?.message || t('registration.genericError') }
  finally { busy.value = false }
}
async function resendOtp() { if (resendWait.value) return; await signupService.sendOtp(form.email, locale.value); startTimer() }
function startTimer() { resendWait.value = 30; const timer = window.setInterval(() => { if (--resendWait.value <= 0) window.clearInterval(timer) }, 1000) }
async function copyLogin() { if (!result.value) return; await navigator.clipboard.writeText(result.value.login); copied.value = true }

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("aside", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, {
          to: "/",
          class: "brand-logo",
          "aria-label": "Bati Vision 360 home"
        }, {
          default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
            _createElementVNode("img", {
              src: "/logo-3.png",
              alt: "Bati Vision 360"
            }, null, -1)
          ]))]),
          _: 1
        }),
        _createVNode(LanguageSelector)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(t)('registration.eyebrow')), 1),
        _createElementVNode("h1", null, _toDisplayString(_unref(t)('registration.heroTitle')), 1),
        _createElementVNode("p", null, _toDisplayString(_unref(t)('registration.heroText')), 1),
        _createElementVNode("ul", null, [
          _createElementVNode("li", null, [
            _cache[15] || (_cache[15] = _createElementVNode("span", {
              class: "benefit-check",
              "aria-hidden": "true"
            }, "✓", -1)),
            _createElementVNode("span", null, _toDisplayString(_unref(t)('registration.benefitOne')), 1)
          ]),
          _createElementVNode("li", null, [
            _cache[16] || (_cache[16] = _createElementVNode("span", {
              class: "benefit-check",
              "aria-hidden": "true"
            }, "✓", -1)),
            _createElementVNode("span", null, _toDisplayString(_unref(t)('registration.benefitTwo')), 1)
          ]),
          _createElementVNode("li", null, [
            _cache[17] || (_cache[17] = _createElementVNode("span", {
              class: "benefit-check",
              "aria-hidden": "true"
            }, "✓", -1)),
            _createElementVNode("span", null, _toDisplayString(_unref(t)('registration.benefitThree')), 1)
          ])
        ]),
        _createElementVNode("p", _hoisted_6, _toDisplayString(_unref(t)('registration.trialMessage')), 1)
      ]),
      _createElementVNode("p", _hoisted_7, "© " + _toDisplayString(new Date().getFullYear()) + " Bati Vision 360", 1)
    ]),
    _createElementVNode("section", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        (step.value === 1)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("h2", null, _toDisplayString(_unref(t)('registration.createTitle')), 1),
              _createElementVNode("p", _hoisted_10, _toDisplayString(_unref(t)('registration.createText')), 1),
              _createElementVNode("fieldset", _hoisted_11, [
                _createElementVNode("legend", _hoisted_12, _toDisplayString(_unref(t)('registration.accountType')), 1),
                _createElementVNode("label", {
                  class: _normalizeClass({ selected: form.type === 'CLIENT' })
                }, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.type) = $event)),
                    type: "radio",
                    value: "CLIENT"
                  }, null, 512), [
                    [_vModelRadio, form.type]
                  ]),
                  _cache[18] || (_cache[18] = _createElementVNode("span", { class: "type-icon" }, "●", -1)),
                  _createElementVNode("strong", null, _toDisplayString(_unref(t)('registration.personal')), 1),
                  _createElementVNode("small", null, _toDisplayString(_unref(t)('registration.personalHelp')), 1)
                ], 2),
                _createElementVNode("label", {
                  class: _normalizeClass({ selected: form.type === 'FIRM_MEMBER' })
                }, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.type) = $event)),
                    type: "radio",
                    value: "FIRM_MEMBER"
                  }, null, 512), [
                    [_vModelRadio, form.type]
                  ]),
                  _cache[19] || (_cache[19] = _createElementVNode("span", { class: "type-icon" }, "▲", -1)),
                  _createElementVNode("strong", null, _toDisplayString(_unref(t)('registration.firmMember')), 1),
                  _createElementVNode("small", null, _toDisplayString(_unref(t)('registration.firmMemberHelp')), 1)
                ], 2),
                _createElementVNode("label", {
                  class: _normalizeClass({ selected: form.type === 'FIRM_OWNER' })
                }, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.type) = $event)),
                    type: "radio",
                    value: "FIRM_OWNER"
                  }, null, 512), [
                    [_vModelRadio, form.type]
                  ]),
                  _cache[20] || (_cache[20] = _createElementVNode("span", { class: "type-icon" }, "◆", -1)),
                  _createElementVNode("strong", null, _toDisplayString(_unref(t)('registration.company')), 1),
                  _createElementVNode("small", null, _toDisplayString(_unref(t)('registration.companyHelp')), 1)
                ], 2)
              ]),
              _createElementVNode("form", {
                onSubmit: _withModifiers(requestOtp, ["prevent"]),
                novalidate: ""
              }, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("label", null, [
                    _createTextVNode(_toDisplayString(_unref(t)('registration.firstName')), 1),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.firstName) = $event)),
                      autocomplete: "given-name",
                      required: ""
                    }, null, 512), [
                      [
                        _vModelText,
                        form.firstName,
                        void 0,
                        { trim: true }
                      ]
                    ])
                  ]),
                  _createElementVNode("label", null, [
                    _createTextVNode(_toDisplayString(_unref(t)('registration.lastName')), 1),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.lastName) = $event)),
                      autocomplete: "family-name",
                      required: ""
                    }, null, 512), [
                      [
                        _vModelText,
                        form.lastName,
                        void 0,
                        { trim: true }
                      ]
                    ])
                  ])
                ]),
                _createElementVNode("label", null, [
                  _createTextVNode(_toDisplayString(_unref(t)('registration.email')), 1),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((form.email) = $event)),
                    type: "email",
                    autocomplete: "email",
                    required: ""
                  }, null, 512), [
                    [
                      _vModelText,
                      form.email,
                      void 0,
                      { trim: true }
                    ]
                  ])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("label", null, [
                    _createTextVNode(_toDisplayString(_unref(t)('registration.password')), 1),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((form.password) = $event)),
                      type: "password",
                      autocomplete: "new-password",
                      required: ""
                    }, null, 512), [
                      [_vModelText, form.password]
                    ])
                  ]),
                  _createElementVNode("label", null, [
                    _createTextVNode(_toDisplayString(_unref(t)('registration.confirmPassword')), 1),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((confirmPassword).value = $event)),
                      type: "password",
                      autocomplete: "new-password",
                      required: ""
                    }, null, 512), [
                      [_vModelText, confirmPassword.value]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("i", {
                    style: _normalizeStyle({ width: passwordStrength.value + '%' })
                  }, null, 4)
                ]),
                _createElementVNode("small", _hoisted_16, _toDisplayString(_unref(t)('registration.passwordHelp')), 1),
                (form.type === 'CLIENT' || form.type === 'FIRM_MEMBER')
                  ? (_openBlock(), _createElementBlock("label", _hoisted_17, [
                      _createTextVNode(_toDisplayString(_unref(t)('registration.invitationCode')), 1),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((form.securityCode) = $event)),
                        autocomplete: "one-time-code",
                        required: ""
                      }, null, 512), [
                        [
                          _vModelText,
                          form.securityCode,
                          void 0,
                          { trim: true }
                        ]
                      ]),
                      _createElementVNode("small", _hoisted_18, _toDisplayString(_unref(t)(form.type === 'FIRM_MEMBER' ? 'registration.firmMemberInvitationHelp' : 'registration.invitationHelp')), 1)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("label", _hoisted_19, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((form.acceptedTerms) = $event)),
                    type: "checkbox",
                    required: ""
                  }, null, 512), [
                    [_vModelCheckbox, form.acceptedTerms]
                  ]),
                  _createElementVNode("span", null, [
                    _createTextVNode(_toDisplayString(_unref(t)('registration.acceptPrefix')) + " ", 1),
                    _createVNode(_component_router_link, {
                      to: "/terms-of-service",
                      target: "_blank"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)('registration.terms')), 1)
                      ]),
                      _: 1
                    }),
                    _createTextVNode(" " + _toDisplayString(_unref(t)('registration.legalAnd')) + " ", 1),
                    _createVNode(_component_router_link, {
                      to: "/privacy-policy",
                      target: "_blank"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)('registration.privacyPolicy')), 1)
                      ]),
                      _: 1
                    })
                  ])
                ]),
                (error.value)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_20, _toDisplayString(error.value), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("button", {
                  class: "primary",
                  disabled: busy.value
                }, _toDisplayString(busy.value ? _unref(t)('common.loading') : _unref(t)('registration.continue')), 9, _hoisted_21)
              ], 32)
            ], 64))
          : (step.value === 2)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createElementVNode("button", {
                  class: "back",
                  onClick: _cache[10] || (_cache[10] = ($event: any) => (step.value = 1))
                }, "← " + _toDisplayString(_unref(t)('registration.back')), 1),
                _cache[21] || (_cache[21] = _createElementVNode("div", { class: "otp-icon" }, "✉", -1)),
                _createElementVNode("h2", null, _toDisplayString(_unref(t)('registration.verifyTitle')), 1),
                _createElementVNode("p", _hoisted_22, _toDisplayString(_unref(t)('registration.verifyText', { email: form.email })), 1),
                _createElementVNode("form", {
                  onSubmit: _withModifiers(completeSignup, ["prevent"])
                }, [
                  _createElementVNode("label", null, [
                    _createTextVNode(_toDisplayString(_unref(t)('registration.verificationCode')), 1),
                    _withDirectives(_createElementVNode("input", {
                      ref_key: "otpInput",
                      ref: otpInput,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((otp).value = $event)),
                      class: "otp",
                      inputmode: "numeric",
                      maxlength: "6",
                      autocomplete: "one-time-code",
                      required: ""
                    }, null, 512), [
                      [
                        _vModelText,
                        otp.value,
                        void 0,
                        { trim: true }
                      ]
                    ])
                  ]),
                  (error.value)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_23, _toDisplayString(error.value), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("button", {
                    class: "primary",
                    disabled: busy.value || otp.value.length < 6
                  }, _toDisplayString(busy.value ? _unref(t)('common.loading') : _unref(t)('registration.createAccount')), 9, _hoisted_24),
                  _createElementVNode("button", {
                    type: "button",
                    class: "text-button",
                    disabled: resendWait.value > 0,
                    onClick: resendOtp
                  }, _toDisplayString(resendWait.value ? _unref(t)('registration.resendIn', { seconds: resendWait.value }) : _unref(t)('registration.resend')), 9, _hoisted_25)
                ], 32)
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                _cache[22] || (_cache[22] = _createElementVNode("div", { class: "success-icon" }, "✓", -1)),
                _createElementVNode("p", _hoisted_26, _toDisplayString(_unref(t)('registration.complete')), 1),
                _createElementVNode("h2", null, _toDisplayString(_unref(t)('registration.readyTitle')), 1),
                _createElementVNode("p", _hoisted_27, _toDisplayString(_unref(t)('registration.readyText')), 1),
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("small", null, _toDisplayString(_unref(t)('registration.username')), 1),
                  _createElementVNode("strong", null, _toDisplayString(result.value?.login), 1),
                  _createElementVNode("button", { onClick: copyLogin }, _toDisplayString(copied.value ? _unref(t)('registration.copied') : _unref(t)('registration.copy')), 1)
                ]),
                _createElementVNode("p", _hoisted_29, _toDisplayString(_unref(t)('registration.usernameHelp')), 1),
                _createElementVNode("button", {
                  class: "primary",
                  onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.$emit('signIn')))
                }, _toDisplayString(_unref(t)('registration.signIn')), 1)
              ], 64)),
        (step.value === 1)
          ? (_openBlock(), _createElementBlock("p", _hoisted_30, [
              _createTextVNode(_toDisplayString(_unref(t)('registration.haveAccount')) + " ", 1),
              _createElementVNode("button", {
                onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.$emit('signIn')))
              }, _toDisplayString(_unref(t)('registration.signIn')), 1)
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})